/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import { Button, GDSButtonProps } from '@leagueplatform/genesis-core';
import { MasonryEngineNodeAction } from '@leagueplatform/masonry-engine';
import { getMasonryActionComponentSemantics } from '../../utils/get-masonry-action-component-semantics.util';

interface MasonryButtonProps extends GDSButtonProps<'button'> {
  action: MasonryEngineNodeAction | undefined;
}

/**
 * A wrapper around the Genesis Button component that helps with masonry renderers with correct semantics based on the action.
 */

export const MasonryButton = React.forwardRef<
  HTMLButtonElement | null,
  MasonryButtonProps
>((props: MasonryButtonProps, ref) => {
  const { action, ...rest } = props;
  const masonryActionComponentSemantics = React.useMemo(
    () => getMasonryActionComponentSemantics({ action }),
    [action],
  );

  return <Button {...masonryActionComponentSemantics} {...rest} ref={ref} />;
});
